import { FormGroup } from "@angular/forms";
import { disabledIntegration } from "./nexsys-form-config.model";
import { ValidationContext } from "@cv-invision/cv.invision-views.ux";
import { IntegrationConfig } from "./product.model";

export const FNC_FORM_CONFIG = {
	fnc: {
		enabled: {
			path: 'fnc.enabled',
			DataType: 'Boolean',
			DisplayText: `FNC`,
			Name: 'enabled',
			customClass: 'product-form-switch',
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: FormGroup, extraData: any) => {
					disabledIntegration(formGroup);
					formGroup.get('fnc')?.setValue(new IntegrationConfig());
					formGroup.get('fnc.enabled')?.setValue($event.checked);
					formGroup.get('fnc').updateValueAndValidity();
				},
			},
		},
		isDefaultProduct: {
			path: 'fnc.isDefaultProduct',
			DataType: 'Boolean',
			DisplayText: `Default Product Configuration`,
			Name: 'isDefaultProduct',
			customClass: 'product-form-switch ms-5',
			required:false,
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: FormGroup, extraData: any) => {
					formGroup.get('fnc.productId')?.setValue(null);
					formGroup.get('fnc.productName')?.setValue(null);

					if ($event.checked) {
						formGroup.get('isOrganizationLevel')?.setValue(false);
						formGroup.get('fnc.productId')?.setValue('unknown');
						formGroup.get('fnc.productName')?.setValue(null);
					}

					formGroup.get('fnc').updateValueAndValidity();
				},
			},
		},
		productId: {
			DataType: 'Selector',
			path: 'fnc.productId',
			UIControl: 'Dropdown',
			DisplayText: 'Product Name',
			label: 'Product Name',
			Name: 'productId',
			customClass: 'product-form-dropdown',
			options: [],
			UIOptions: {
				ShowClearButton: true,
				showLabel: true,
			},
			isRequired: function(control, jsonModelService: ValidationContext) {
				return jsonModelService.IsEmpty() && (jsonModelService.FindValue('isDefaultProduct') === false ) && jsonModelService.FindValue('enabled');
			},
			Visible: function(control, jsonModelService: ValidationContext) {
				const optionSelected = jsonModelService.FindValue('isDefaultProduct');
				return (optionSelected === false) || false;

			},
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: any, formConfigModel: any) => {
					const value = $event.value;
					if (value !== '' && value !== null && value !== undefined) {
						const indexOption = formConfigModel.options.findIndex(element => element.value === value);
						const option = formConfigModel.options[ indexOption ];
						formGroup.get('integration.productName')?.setValue(option?.label);
					} else {
						formGroup.get('integration.productId')?.setValue(null);
						formGroup.get('integration.productName')?.setValue(null);
					}
				},
			},
		},
		productName: {
			DataType: 'String',
			path: 'nexsys.productId',
			DisplayText: 'Product Name',
			label: 'Product Name',
			Name: 'productId',
			required: false,
			hidden: true,
		},
		isFhaProduct: {
			path: 'fnc.isFhaProduct',
			DataType: 'Boolean',
			DisplayText: `Is a FHA Product`,
			Name: 'isFhaProduct',
			customClass: 'product-form-switch ms-5',
			required: false,
			Visible: function(control, jsonModelService: ValidationContext) {
				const optionSelected = jsonModelService.FindValue('isDefaultProduct');
				return (optionSelected === false) || false;

			}
		},
		isOrderIncomeStatement: {
			path: 'fnc.isOrderIncomeStatement',
			DataType: 'Boolean',
			DisplayText: `Is Order Income Statement`,
			Name: 'isOrderIncomeStatement',
			customClass: 'product-form-switch  ms-3',
			required: false,
			hidden: false,
		},
		isOrderRentSchedule: {
			path: 'fnc.isOrderRentSchedule',
			DataType: 'Boolean',
			DisplayText: `Is Order Rent Schedule`,
			Name: 'isOrderRentSchedule',
			customClass: 'product-form-switch  ms-3',
			required: false,
			hidden: false
		},
		defaultFhaNumber: {
			path: 'fnc.defaultFhaNumber',
			DataType: 'String',
			DisplayText: `Default FHA Number`,
			Name: 'defaultFhaNumber',
			customClass: '',
			required: false,
			Visible: function(control, jsonModelService: ValidationContext) {
				const optionSelected = jsonModelService.FindValue('isFhaProduct');
				return optionSelected || false;

			}
		}
	}
}
